/* eslint-disable */

const notification = {
  namespaced: true,
  state: {
    my_nte_item: [],
    asm_nte_item: [],
    coaching_item: [],
    post_request: [],
    evaluation_item: [],
    evaluation_item_asm: [],
    my_contract_memo_item: [],
    payslip_item: 0
  },
  getters: {},
  actions: {
    LOAD_PAYSLIP({ commit }) {
      axios
        .get("api/payslip/unread/count")
        .then(resp => {
          let payslip_item = Number(resp.data);
          console.log("payslip count=>", payslip_item);
          commit("SET_PAYSLIP", payslip_item);
        })
        .catch(error => {
          console.log(error);
        });
    },

    LOAD_EVALUATION({ commit }) {
      axios
        .get("api/evaluation/counter")
        .then(resp => {
          let evaluation_item = resp.data;
          commit("SET_EVALUATION", evaluation_item);
        })
        .catch(error => {
          console.log(error);
        });
    },

    LOAD_EVALUATION_ASM({ commit }) {
      axios
        .get("api/evaluation/counter/get/asm")
        .then(resp => {
          let evaluation_item_asm = resp.data;
          commit("SET_EVALUATION_ASM", evaluation_item_asm);
        })
        .catch(error => {
          console.log(error);
        });
    },

    LOAD_REQUEST({ commit }) {
      axios
        .get("api/notification/counter")
        .then(resp => {
          let post_request = resp.data;
          commit("SET_POSTS", post_request);
        })
        .catch(error => {
          console.log(error);
        });
    },

    NTE_NOTIFY_ME({ commit }) {
      axios
        .get("api/notifyme/nte/counter")
        .then(resp => {
          let my_nte_item = resp.data;
          commit("SET_NTE_NOTIFY_ME", my_nte_item);
        })
        .catch(error => {
          console.log(error);
        });
    },

    NTE_NOTIFY_ASM({ commit }) {
      axios
        .get("api/notifynte/counter")
        .then(resp => {
          let asm_nte_item = resp.data;
          commit("SET_NTE_NOTIFY_ASM", asm_nte_item);
        })
        .catch(error => {
          console.log(error);
        });
    },
    COACHING_COUNTER({ commit }) {
      axios
        .get("api/coaching/counter")
        .then(resp => {
          let coaching_item = resp.data;
          commit("SET_COACHING_NOTIFY", coaching_item);
        })
        .catch(error => {
          console.log(error);
        });
    },
    CONTRACT_MEMO_NOTIFY_ME({ commit }) {
      axios
        .get("api/notifyme/contractmemo/counter")
        .then(resp => {
          let my_contract_memo_item = resp.data;
          commit("SET_CONTRACT_MEMO_NOTIFY_ME", my_contract_memo_item);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mutations: {
    //PAYSLIP NOTIFICATION COUNTER ALL
    SET_PAYSLIP(state, payslip_item) {
      state.payslip_item = payslip_item;
    },

    //EVALUATION NOTIFICATION COUNTER ALL
    SET_EVALUATION(state, evaluation_item) {
      state.evaluation_item = evaluation_item;
    },

    //EVALUATION NOTIFICATION COUNTER ASM
    SET_EVALUATION_ASM(state, evaluation_item_asm) {
      state.evaluation_item_asm = evaluation_item_asm;
    },

    //POST FOR NOTIFICATION
    SET_POSTS(state, post_request) {
      state.post_request = post_request;
    },

    //NOTIFY MY NTE TRACKER
    SET_COACHING_NOTIFY(state, coaching_item) {
      state.coaching_item = coaching_item;
    },

    //NOTIFY MY NTE TRACKER
    SET_NTE_NOTIFY_ME(state, my_nte_item) {
      state.my_nte_item = my_nte_item;
    },

    //NOTIFY ASM NTE TRACKER
    SET_NTE_NOTIFY_ASM(state, asm_nte_item) {
      state.asm_nte_item = asm_nte_item;
    },

    //NOTIFY CONTRACT/MEMO TRACKER
    SET_CONTRACT_MEMO_NOTIFY_ME(state, my_contract_memo_item) {
      state.my_contract_memo_item = my_contract_memo_item;
    }
  }
};

export default notification;



// WEBPACK FOOTER //
// ./src/modules/userNotification.js